import Vue from 'vue';
import Vuex from 'vuex'
import VueRouter from 'vue-router';
import DashboardPlugin from './dashboard-plugin';
import VueSweetalert2 from 'vue-sweetalert2';
import ElementUI from 'element-ui';
import { i18n } from "./vue-i18n-plugin"
import { handleAppLanguage } from "./util/i18n"
import axios from 'axios';

// Datatable
import 'element-ui/lib/theme-chalk/index.css';

import { DataTables, DataTablesServer } from 'vue-data-tables'
Vue.use(DataTables)
Vue.use(DataTablesServer)

// Font-awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCreditCard, faReceipt, faFileExport, faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons'
import { faApplePay, faGoogle, faLine } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faCreditCard, faReceipt, faFileExport, faMapMarkedAlt, faApplePay, faGoogle, faLine);
Vue.component('font-awesome-icon', FontAwesomeIcon);

// Vuefire
// import {rtdbPlugin} from 'vuefire';
import { firestorePlugin } from 'vuefire';

// Plugins
import App from './App.vue';

// router setup
import routes from './routes/routes';

import store from './store'
import Axios from 'axios'
import './registerServiceWorker'
// ref: https://scotch.io/tutorials/handling-authentication-in-vue-using-vuex
Vue.prototype.$http = Axios;

// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);
Vue.use(Vuex)
Vue.use(ElementUI, {
  // Doc -> https://element.eleme.io/#/en-US/component/i18n#compatible-with-vue-i18n-6-x
  i18n: (key, value) => i18n.t(key, value)
})
// Vue.use(rtdbPlugin);
Vue.use(firestorePlugin);
Vue.use(VueSweetalert2);

//WARNING: PUSHER TEST
// Vue.use(require('./pusher'), {
//   apiKey: '8cc977fef40f0a1f5c70',
//   options: {
//     cluster: 'ap3',
//     forceTLS: true
//   }
// });

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  mode: 'history', // 從url拿掉#，避免line衝突 
  base: process.env.BASE_URL,
  linkActiveClass: 'active'
});

router.beforeEach(async (to, from, next) => {

  handleAppLanguage(to)

  // 如果 router 轉跳的頁面需要驗證 requiresAuth: true
  // console.log('to=', to.fullPath, '| from=', from.fullPath);
  if (to.matched.some(record => {
    if (record.name) {
      document.title = process.env.VUE_APP_ADMINTITLE + record.name;
      
    } else {
      document.title = process.env.VUE_APP_ADMINTITLE;
    }
    // console.log(record.name, record.meta.requiresAuth);
    return record.meta.requiresAuth;
  })) {
    // 如果沒有 token 
    // console.log('token?', JSON.stringify(store.state));
    
    if (store.state.user && store.state.user.id) {

      next(); // 往下繼續執行
    } else {
      // 嘗試呼叫 /me 確認 server session
      const meHost = window.location.host ==='localhost:8080'? process.env.VUE_APP_APIHOST:'/console/apis'
      try {
        const response = await Axios.get(`${meHost}/gaa/me`);
        const user = response.data;
        if (user) {
          console.log('user store commit ', user);
          store.commit('auth_success', user);
          console.log('debug store user ', store.state.user);
          next();
        } else {
          switch (store.state.lastPortalType) {
            case 'gaa':
              next({ path: '/gaa-login' });
              break;
            case 'si':
              next({ path: '/si-login' });
              break;
            case 'eaa':
              next({ path: '/eaa-login' });
              break;
            default:
              next({ path: '/eaa-login' });
              break;
          }
        }
      } catch (e) {
        // 401 or network error → redirect to login
        console.log('auth check failed, redirect to login', e.response && e.response.status);
        switch (store.state.lastPortalType) {
          case 'gaa':
            next({ path: '/gaa-login' });
            break;
          case 'si':
            next({ path: '/si-login' });
            break;
          case 'eaa':
            next({ path: '/eaa-login' });
            break;
          default:
            next({ path: '/eaa-login' });
            break;
        }
      }
    }
  } else {
    next(); // 往下繼續執行
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  store,
  router,
  i18n
});
